import { render, staticRenderFns } from "./DetryBillView.vue?vue&type=template&id=0fb744c5"
import script from "./DetryBillView.vue?vue&type=script&lang=js"
export * from "./DetryBillView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports